import Flux from 'lib/flux';
import TourAvailabilityConstants from 'constants/tour_availability';
import TourAvailabilityService from 'services/tour_availability';
import Immutable from 'immutable';

const TourAvailabilityActionCreator = Flux.createActionCreator({
  filterDates(guests, date, hasTicketCapacityEnabled) {
    this.dispatchAction(
      TourAvailabilityConstants.FILTER_DATES,
      guests,
      date,
      hasTicketCapacityEnabled
    );
  },

  loadAPIDates(tourId, locationId, setFields) {
    this.dispatchAction(TourAvailabilityConstants.LOAD_DATES);

    TourAvailabilityService.getSchedule(tourId, locationId).then((res) => {
      if (res.data) {
        const availableDates = res.data.schedule.data.attributes.times;
        this.dispatchAction(
          TourAvailabilityConstants.LOAD_API_DATES_FINISHED,
          Immutable.Map(availableDates)
        );
        setFields();
      }
    });
  },

  getAvailableDates(tourId, setDates) {
    this.dispatchAction(TourAvailabilityConstants.GET_AVAILABLE_DATES);

    TourAvailabilityService.getAvailableDates(tourId).then((res) => {
      if (res.data) {
        const availableDates = res.data.available_dates;

        this.dispatchAction(
          TourAvailabilityConstants.GET_AVAILABLE_DATES_FINISHED,
          Immutable.Map(availableDates)
        );
        setDates(res);
      }
    });
  },
});

export default TourAvailabilityActionCreator;
